// removed by extract-text-webpack-plugin
module.exports = {"inputText":"wmf-2exwMAR6"};


//////////////////
// WEBPACK FOOTER
// ./src/compenents/changepassword/changepassword.module.less
// module id = 4756
// module chunks = 0